import * as React from "react";
import Dialog from "@mui/material/Dialog";
import styled from "@emotion/styled";
import InputField from "../../fields/input-field/InputField";
import { Form, Formik, FormikConfig, FormikHelpers } from "formik";
import FormModal from "../../modals/form-modal/FormModal";
import {
  CreateOwnersFormEnums,
  I_OwnersForm,
  initialCreateOwnersFormState
} from "./util/for.util";
import RadioDuoField from "../../fields/radio-duo-field/RadioDuoField";

import { createOwnersValidation } from "./validation.util";
import { useGetCountriesMutation } from "@/src-refactor/modules/store/qrtk/services/geoLocation/geoLocation.qrtk";
import { YupProvider } from "../../../context/RequiredFields.context";
import { Grid } from "@mui/material";
import BtnSimple from "../../buttons/BtbSimple";
import { useCheckExitsOwnerMutation } from "@/src-refactor/modules/store/qrtk/services/owners/owners.qrtk";
import toast from "react-hot-toast";
import CardsOwnerSimple from "./CardsOwnerSimple";
import { I_GENERIC_ITEMS } from "../../../model/interface/items.interface";
import { C_IDENTIFICATION } from "../../../model/const/indetification.const";
import DatePickerField from "../../fields/date-field/DateField";
import {
  A_YES_AND_NOT,
  C_YES_AND_NOT
} from "../../../model/const/yes-and-not.conts";
import MxButtonStartIcon from "@rf-l1/buttons/MxButtonStartIcon";
import { IconKey } from "@tabler/icons-react";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import MxFormSubTitleAndDescription from "@rf-l1/page/form/MxFormSubTitleAndDescription";
import { IEventChange } from "@rf-model/event-change.model";
import { debounce } from "lodash";
import { HToastCatchServerError } from "@rf-helper/cath-error-server";

interface ICreateOwnersFormPorps {
  emitPayload?: (payload: any) => void;
  emitPayloadExist?: (payload: any) => void;
}

export interface PayloadOwnerForm extends I_OwnersForm {
  id: number;
  new: boolean;
  label: string;
}

const CreateOwnersForm: React.FC<ICreateOwnersFormPorps> = props => {
  const recibePayload = (payload: I_OwnersForm) => {
    if (props.emitPayload) {
      const completePayload: PayloadOwnerForm = {
        ...payload,
        id: Date.now(),
        new: true,
        label: `${payload.name}`
      };
      props.emitPayload(completePayload);
    }
  };

  const recibeExistent = (payload: I_GENERIC_ITEMS) => {
    if (props.emitPayloadExist) {
      props.emitPayloadExist(payload);
    }
  };

  return (
    <FormModal
      title="Crear propietario"
      closeModalId="btn-create-owners-close"
      FormComponent={
        <FormOwnerContent
          emitPayload={recibePayload}
          emitPayloadExist={recibeExistent}
        />
      }
      btnToggle={
        <MxButtonStartIcon
          label="Agregar propietario"
          bgColorIcon="primary.main"
          colorText="grey.600"
          icon={<IconKey size={19} color="white" />}
          id="btn-create-owners"
        />
      }
    />
  );
};

export default CreateOwnersForm;

interface IFormContentProps {
  modalToggle?: () => void;
  emitPayload: (payload: I_OwnersForm) => void;
  emitPayloadExist: (payload: I_GENERIC_ITEMS) => void;
  noValidateIdentification?: boolean;
  initialData?: I_OwnersForm;
  onSubmit?: (
    values: I_OwnersForm,
    FormikHelper: FormikHelpers<I_OwnersForm>
  ) => void;
  isNoModal?: boolean;
  isEdit?: boolean;
}

export const FormOwnerContent: React.FC<IFormContentProps> = props => {
  const [hasCompany, setHasCompany] = React.useState(false);
  const [GET_COUNTRIES_M, GET_COUNTRIES_DATA] = useGetCountriesMutation();
  const [CHECK_MARCHER_M, CHECK_MARCHER_DATA] = useCheckExitsOwnerMutation();
  const [identification_type, setIdentification_type] = React.useState("");

  const COUNTRIES = React.useMemo(
    () =>
      GET_COUNTRIES_DATA.data?.map(item => ({
        label: item.description,
        value: item.id
      })),
    [GET_COUNTRIES_DATA.data]
  );

  const onFindCountries = (text?: string) => {
    GET_COUNTRIES_M({
      query: { q: text }
    })
      .unwrap()
      .catch(e => HToastCatchServerError(e));
  };

  const formikConfig: FormikConfig<I_OwnersForm> = {
    initialValues: {
      ...initialCreateOwnersFormState,
      ...props?.initialData
    },
    onSubmit: (values: any, formikHelpers: FormikHelpers<any>) => {
      props.emitPayload(values);
      formikHelpers.resetForm();
      if (props.modalToggle) {
        props.modalToggle();
      }
      props.onSubmit && props.onSubmit(values, formikHelpers);
    },
    onReset: () => {},
    validationSchema: createOwnersValidation,
    validateOnBlur: false,
    validateOnChange: false
  };

  const removeGuion = (key: string): string => {
    return key.replace(/-/g, "");
  };

  const onChangeIdentificationType = (e: IEventChange<I_GENERIC_ITEMS[]>) => {
    if (e?.target?.value?.length == 0) return;
    setIdentification_type(e.target.value[0].value);
  };

  const searchOwner = (e: any) => {
    const request = CHECK_MARCHER_M({
      query: {
        identification: removeGuion(e),
        identification_type: identification_type
      }
    }).unwrap();
    toast.promise(request, {
      loading: "Verificando propietario",
      success: "Propietario verificado",
      error: "Error al verificar propietario"
    });
  };
  const validateOwner = React.useCallback(
    debounce((e: any, name?: string) => {
      if (props.noValidateIdentification) return;
      if (!e || e == "") return;
      if (identification_type == "") return;

      if (identification_type == C_IDENTIFICATION.PASAPORTE.value && e.length >= 7) {
        searchOwner(e);
      }

      if (identification_type == C_IDENTIFICATION.CEDULA.value && e.length >= 11) {
        searchOwner(e);
      }
    }, 500),
    [props.noValidateIdentification, identification_type]
  );

  const OwnerValidate = React.useMemo(() => {
    if (CHECK_MARCHER_DATA.isSuccess) {
      return {
        data: CHECK_MARCHER_DATA.data,
        status: true
      };
    }
    return {
      data: [],
      status: false
    };
  }, [CHECK_MARCHER_DATA]);

  React.useEffect(() => {
    onFindCountries();
  }, []);

  return (
    <Grid container item xs={12}>
      <Grid container item xs={12}>
        <CardsOwnerSimple
          data={CHECK_MARCHER_DATA.data}
          emitPayloadExist={props.emitPayloadExist}
          modalToggle={props.modalToggle}
        />
      </Grid>
      {OwnerValidate.data.length == 0 && (
        <Grid container xs={12} component={"div"}>
          <YupProvider schema={createOwnersValidation}>
            <Formik {...formikConfig} enableReinitialize={true}>
              {formikProps => {
                React.useEffect(() => {
                  if (formikProps.values.has_company.length > 0) {
                    setHasCompany(
                      formikProps.values.has_company[0].value ==
                        C_YES_AND_NOT.YES.value
                    );
                  } else {
                    setHasCompany(false);
                  }
                }, [formikProps.values.has_company]);

                const labelId = React.useMemo(() => {
                  if (formikProps.values.identification_type.length > 0) {
                    return formikProps.values.identification_type[0].label;
                  } else {
                    return "Pasaporte o cédula";
                  }
                }, [formikProps.values.identification_type]);

                const disabledIdentificationField = React.useMemo(() => {
                  return formikProps.values.identification_type.length > 0;
                }, [formikProps.values.identification_type]);

                return (
                  <Form>
                    <Grid container my={hasCompany ? 1 : 2} spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <MxFormL3AutoComplete
                          withreacthookform={0}
                          name={CreateOwnersFormEnums.identification_type}
                          items={[
                            C_IDENTIFICATION.CEDULA,
                            C_IDENTIFICATION.PASAPORTE
                          ]}
                          label="Tipo de documento"
                          onSelect={onChangeIdentificationType}
                          // onChange={onChangeIdentificationType}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <InputField
                          name={CreateOwnersFormEnums.number_identification}
                          label={labelId}
                          maskType={
                            labelId == C_IDENTIFICATION.CEDULA.label
                              ? "CedulaMask"
                              : "input"
                          }
                          // @ts-ignore
                          onChange={validateOwner}
                          // onBlur={validateOwner}
                          disabled={!disabledIdentificationField}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <InputField
                          name={CreateOwnersFormEnums.name}
                          label="Nombre completo"
                          maskType="onlyText"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputField
                          name={CreateOwnersFormEnums.email}
                          label="Correo electrónico"
                          type="email"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePickerField
                          name={CreateOwnersFormEnums.birthdate}
                          label="Fecha de nacimiento"
                          disableFuture
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputField
                          name={CreateOwnersFormEnums.mobile_phone}
                          label="Teléfono celular"
                          maskType="PhoneMask"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MxFormL3AutoComplete
                          withreacthookform={0}
                          name={CreateOwnersFormEnums.country}
                          label="País"
                          items={COUNTRIES ?? []}
                          onSearch={onFindCountries}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputField
                          name={CreateOwnersFormEnums.city}
                          label="Ciudad"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputField
                          name={CreateOwnersFormEnums.sector}
                          label="Sector"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputField
                          name={CreateOwnersFormEnums.address}
                          label="Dirección"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputField
                          name={CreateOwnersFormEnums.phone}
                          label="Teléfono de oficina"
                          maskType="PhoneMask"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputField
                          name={CreateOwnersFormEnums.residential_phone}
                          label="Teléfono residencial"
                          maskType="PhoneMask"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputField
                          name={CreateOwnersFormEnums.fax}
                          label="Fax"
                          maskType="PhoneMask"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <RadioDuoField
                          label="¿Tiene una empresa?"
                          name={CreateOwnersFormEnums.has_company}
                          option={A_YES_AND_NOT}
                        />
                      </Grid>
                      <Grid
                        container
                        item
                        spacing={2}
                        xs={12}
                        display={hasCompany ? "flex" : "none"}
                      >
                        <Grid item xs={12} textAlign="center">
                          <MxFormSubTitleAndDescription
                            label="Datos de la empresa"
                            description=""
                            isRequired={false}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <InputField
                            name={CreateOwnersFormEnums.company}
                            label="Compañía"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <InputField
                            name={CreateOwnersFormEnums.company_occupation}
                            label="Cargo"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <InputField
                            name={CreateOwnersFormEnums.company_identification}
                            label="RNC"
                            maskType="onlyNumber"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <InputField
                            name={CreateOwnersFormEnums.company_email}
                            label="Correo electrónico"
                            type="email"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <InputField
                            name={
                              CreateOwnersFormEnums.company_registration_comercial
                            }
                            label="Número de registro mercantil"
                            maskType="onlyNumber"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <InputField
                            name={CreateOwnersFormEnums.company_fax}
                            label="Fax"
                            maskType="PhoneMask"
                          />
                        </Grid>
                      </Grid>

                      <Grid item xs={12} alignItems="center">
                        <BtnContainer isNoModal={props.isNoModal}>
                          <BtnSimple
                            type="submit"
                            // onClick={() => formikProps.submitForm()}
                          >
                            {props.isEdit
                              ? "Actualizar propietario"
                              : "Agregar propietario"}
                          </BtnSimple>
                        </BtnContainer>
                      </Grid>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </YupProvider>
        </Grid>
      )}
    </Grid>
  );
};

const CustomDialog = styled(Dialog)`
  .MuiPaper-root {
    border-radius: 20px;
  }
`;

const ContainerFields = styled(Form)`
  margin-top: 20px;
`;

const FieldsContainer = styled.div`
  display: grid;
  grid-template-rows: repeat(6, minmax(0, 1fr));
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 30px;
  @media only screen and (min-width: 300px) and (max-width: 1200px) {
    width: 100%;
    grid-template-rows: repeat(1, minmax(0, 1fr));
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 20px;
  }
  > * {
    align-items: start;
  }
`;

const CompanyFieldsContainer = styled.div`
  display: grid;
  grid-template-rows: repeat(4, minmax(0, 1fr));
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  @media only screen and (min-width: 300px) and (max-width: 1200px) {
    width: 100%;
    grid-template-rows: repeat(1, minmax(0, 1fr));
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 20px;
  }
  margin-bottom: 20px;
`;

const CompanyTitle = styled.div`
  text-align: center;
  font-family: var(--FF-SF);
  color: var(--m-color-blue-03);
  font-size: 18px;
  margin: 20px;
`;

const BtnContainer = styled.div((props: { isNoModal?: boolean }) => {
  return `
  width: 100%;
  display: flex;
  justify-content: ${props.isNoModal ? "end" : "center"};
`;
});
